import { Children, cloneElement } from "react";
import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated as isAuthenticatedSelector } from "app/pages/Auth/authSelectors";
import { buildOnAuthSuccessRedirect } from "app/utils/routerUtils";
import { useSelector } from "react-redux";

const BookingPrivateRoute = ({ authPath, children }) => {
	const isAuthenticated = useSelector(isAuthenticatedSelector);
	const { pathname, search } = useLocation();

	const childrenWithProps = Children.map(children, child => {
		return cloneElement(child);
	});
	// TODO ROUTER isAuthenticated renvoie toujours false en SSR
	return isAuthenticated ? (
		childrenWithProps
	) : (
		<Navigate replace to={buildOnAuthSuccessRedirect(authPath, pathname, search)} />
	);
};

BookingPrivateRoute.propTypes = {
	authPath: PropTypes.string,
};

export default BookingPrivateRoute;
